import { Typography } from "@material-ui/core";
import React from "react";
import { FormattedHTMLMessage, FormattedMessage } from "react-intl";
import ActionDialog from "../../ActionDialog";
import {
  demoteFromAgentAction,
  showErrorMessage,
  showSuccessMessage,
} from "../../../../actions";
import { useDispatch } from "react-redux";
import { resolveErrorMessage } from "../../../../util";
import LoadingSpinner from "../../LoadingSpinner";

const DemoteFromAgentDialog = ({ open, onClose, user, fetchUser }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState(false);

  const demoteFromAgent = async () => {
    setLoading(true);
    try {
      await demoteFromAgentAction({ editedUserId: user.id });
      dispatch(showSuccessMessage("app.edit.sucesfully"));
      await fetchUser();
    } catch (e) {
      const errorMessage = resolveErrorMessage(e);
      dispatch(showErrorMessage(errorMessage));
    } finally {
      setLoading(false);
      onClose();
    }
  };

  return (
    <ActionDialog
      title="app.confirmations"
      open={open}
      onClose={onClose}
      onAccept={demoteFromAgent}
      textConfirm="app.ok"
      disableConfirmButton={loading}
    >
      {loading ? (
        <LoadingSpinner
          message={<FormattedMessage id="app.loading.updating" />}
        />
      ) : (
        <>
          <Typography variant="body1">
            <FormattedHTMLMessage id="app.confirm.demoteFromAgent" />
          </Typography>
        </>
      )}
    </ActionDialog>
  );
};

export default React.memo(DemoteFromAgentDialog);
